/* eslint-disable max-len */
import { LitElement, html, css } from 'lit';
import { consume } from '@lit/context';
import { customElement, property } from 'lit/decorators.js';
import { wishlistContext } from '../../contexts/wishlist-context';

@customElement('product-wishlist')
class ProductWishlist extends LitElement {
  @consume({ context: wishlistContext, subscribe: true })
  accessor wishlist;

  @property({ type: Number, attribute: 'variant-id' })
  accessor variantId;

  @property({ type: Number, attribute: 'product-id' })
  accessor productId;

  @property({ type: Number, attribute: 'customer-id' })
  accessor customerId;

  @property({ type: Boolean })
  accessor isWishlisted;

  static styles = css`
    button {
      color: inherit;
      font-family: inherit;
      font-size: 100%;
      font-weight: inherit;
      line-height: inherit;
      margin: 0;
      padding: 0;
      text-transform: none;
      cursor: pointer;
      -webkit-appearance: button;
      background-color: transparent;
      background-image: none;
      border: 0;
      width: 22px;
    }

    svg {
      width: 100%;
      height: 100%;
    }

    .hidden {
      display: none;
    }
  `;

  constructor() {
    super();
    this.currentWishlist = null;
  }

  connectedCallback() {
    super.connectedCallback();
    this.getCurrentWishlist();
    this._handleAddWishlistFromStorage();
  }

  _handleAddWishlistFromStorage = async () => {
    const variantId = window.sessionStorage.getItem('pdpAddToWishlist');
    if (variantId) {
      this.currentWishlist = await this.wishlist.addToWishlist(variantId);
      this.checkIsWishlisted();
      window.sessionStorage.removeItem('pdpAddToWishlist');
    }
  };

  getCurrentWishlist = async () => {
    this.currentWishlist = await this.wishlist.getWishlist({ skipCache: true });
    this.checkIsWishlisted();
  };

  checkIsWishlisted = () => {
    this.isWishlisted = this.currentWishlist.products.some(
      (product) => product.product_id === this.productId,
    );
  };

  toggleWishlist = async () => {
    if (!this.customerId) {
      window.localStorage.removeItem('wishlist');
      window.sessionStorage.setItem('pdpAddToWishlist', this.variantId);
      const handle = encodeURIComponent(window.location.pathname);
      window.location = `${window.Shopify.routes.root}account/login?return_url=${handle}`;
      return;
    }

    if (this.isWishlisted) {
      this.currentWishlist = await this.wishlist.removeFromWishlist(
        this.variantId,
      );
      this.checkIsWishlisted();
    } else {
      this.currentWishlist = await this.wishlist.addToWishlist(this.variantId);
      this.checkIsWishlisted();
    }
  };

  renderHeartTemplate = () => {
    if (this.isWishlisted) {
      return html`
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="18"
          viewBox="0 0 22 19"
          fill="none"
        >
          <path
            fill="#565351"
            stroke="#565351"
            stroke-width="0.3"
            d="M15.554.334c2.847 0 5.121 2.298 5.413 5.466.023.14.117.877-.17 2.077-.415 1.733-1.373 3.308-2.77 4.556l-7.087 6.234-6.968-6.234c-1.396-1.248-2.354-2.824-2.769-4.556-.287-1.2-.193-1.937-.17-2.077C1.325 2.632 3.6.333 6.446.333c1.866 0 3.53.986 4.499 2.62a5.395 5.395 0 014.61-2.62z"
          ></path>
        </svg>
      `;
    }
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="18"
        viewBox="0 0 22 19"
        fill="none"
      >
        <path
          fill="currentColor"
          stroke="currentColor"
          stroke-width="0.3"
          d="M18.97 5.42C18.708 2.57 16.66.5 14.1.5c-1.707 0-3.27.906-4.149 2.357C9.08 1.387 7.58.5 5.901.5 3.34.5 1.292 2.569 1.03 5.42c-.02.126-.106.789.153 1.87.373 1.558 1.235 2.977 2.492 4.1L9.946 17l6.379-5.61c1.257-1.123 2.119-2.541 2.492-4.1.259-1.081.174-1.744.153-1.87zm-.827 1.713c-.34 1.424-1.13 2.721-2.281 3.75L9.95 16.081l-5.81-5.198c-1.153-1.03-1.942-2.327-2.283-3.751-.245-1.023-.144-1.6-.144-1.605l.005-.034c.225-2.498 1.984-4.311 4.183-4.311 1.623 0 3.05.983 3.729 2.564l.319.745.318-.745c.668-1.557 2.171-2.564 3.832-2.564 2.199 0 3.958 1.813 4.188 4.344 0 .005.101.583-.144 1.606z"
        ></path>
      </svg>
    `;
  };

  render() {
    return html`
      <button type="button" @click=${this.toggleWishlist}>
        <span>${this.renderHeartTemplate()}</span>
      </button>
    `;
  }
}

export default ProductWishlist;
